﻿export function packageSelect() {
  const buttons = document.getElementsByClassName("js-package-select");
  for (let button of buttons) {
    button.addEventListener("click", function (e) {
      e.preventDefault();

      const packageId = button.dataset['packageid'];
      const packageName = button.dataset['packagename'];
      const redirect = button.href;

      if (packageId && packageName) {
        gtag("event", "order_product_clicked", {
          package_id: packageId,
          package_name: packageName,
          utm_source: localStorage.getItem('utm_source') || '(not set)',
          utm_medium: localStorage.getItem('utm_medium') || '(not set)',
          utm_campaign: localStorage.getItem('utm_campaign') || '(not set)',
          utm_term: localStorage.getItem('utm_term') || '(not set)',
          utm_content: localStorage.getItem('utm_content') || '(not set)'
        });

        localStorage.setItem('packageId', packageId);
      }

      window.location.href = redirect;
    });
  }
}
